exports.components = {
  "component---src-pages-facts-js": () => import("./../../../src/pages/facts.js" /* webpackChunkName: "component---src-pages-facts-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

